import React, { createContext, useContext, useEffect, useRef, useState, useCallback } from 'react';
const SOCKET_URL = process.env.REACT_APP_SOCKET_GAME_URL || "ws.xyztown.info";

const WebSocketContext = createContext(null);

export const WebSocketProvider = ({ children }) => {
  const ws = useRef(null);
  const [isConnected, setIsConnected] = useState(false);
  const listeners = useRef({});

  const addListener = useCallback((eventType, callback) => {
    if (!listeners.current[eventType]) {
      listeners.current[eventType] = [];
    }
    listeners.current[eventType].push(callback);
  }, []);

  const removeListener = useCallback((eventType, callback) => {
    console.log(`Removing listener for event: ${eventType}`);
    if (listeners.current[eventType]) {
      listeners.current[eventType] = listeners.current[eventType].filter(
        cb => cb !== callback
      );
    }
  }, []);

  const disconnect = useCallback(() => {
    if (ws.current) {
      ws.current.close();
      ws.current = null;
    }
  }, []);

  const connectWebSocket = useCallback(() => {
    console.trace('connectWebSocket chiamato da:');
    if (ws.current) ws.current.close();

    ws.current = new WebSocket(`wss://${SOCKET_URL}`);
    console.log(`Connecting to WebSocket at wss://${SOCKET_URL}`);

    ws.current.onopen = () => {
      console.log('WebSocket connesso');
      setIsConnected(true);
      // ws.current.send('LOGIN|user123');
    };

    ws.current.onmessage = (event) => {
      try {
        const eventType = event.data.split(";")[0] || 'message';
        const data = event.data.split(";").slice(1) || event.data;

        if (listeners.current[eventType]) {
          listeners.current[eventType].forEach(cb => cb(data));
        }
        if (listeners.current['*']) {
          listeners.current['*'].forEach(cb => cb(data));
        }
      } catch {
        if (listeners.current['raw']) {
          listeners.current['raw'].forEach(cb => cb(event.data));
        }
      }
    };

    ws.current.onerror = (error) => {
      console.error('WebSocket error:', error);
    };

    ws.current.onclose = () => {
      console.log('WebSocket disconnesso');
      setIsConnected(false);
    };

  }, []);


  const sendMessage = (message) => {
    console.log('Invio WebSocket:', message);
    if (ws.current && ws.current.readyState === WebSocket.OPEN) {
      ws.current.send(message);
    } else {
      console.warn('WebSocket non connesso:', message);
    }
  };

  return (
    <WebSocketContext.Provider value={{ isConnected, sendMessage, addListener, removeListener, disconnect, connectWebSocket }}>
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocket = () => useContext(WebSocketContext);